import PropTypes from 'prop-types';

export const listIcon = [
  'icon-edit',
  'icon-delete',
  'icon-switch',
  'icon-arrow',
  'icon-download',
  'icon-message-disabled',
  'icon-message',
  'icon-reject-disabled',
  'icon-reject',
  'icon-accept-disabled',
  'icon-accept',
  'icon-save',
];

export default function IconSvg(props) {
  const { name, onClick, className } = props;
  let iconElement;

  switch (name) {
    case 'icon-save':
      iconElement = (
        <svg
          width="36"
          height="37"
          viewBox="0 0 36 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="1"
            width="35"
            height="35"
            rx="7.5"
            fill="white"
            stroke="#E6EBF1"
          />
          <path
            d="M21.3333 25V19.6667H14.6667V25M14.6667 13V16.3333H20M22.6667 25H13.3333C12.9797 25 12.6406 24.8595 12.3905 24.6095C12.1405 24.3594 12 24.0203 12 23.6667V14.3333C12 13.9797 12.1405 13.6406 12.3905 13.3905C12.6406 13.1405 12.9797 13 13.3333 13H20.6667L24 16.3333V23.6667C24 24.0203 23.8595 24.3594 23.6095 24.6095C23.3594 24.8595 23.0203 25 22.6667 25Z"
            stroke="#1E1E1E"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;
    case 'icon-download':
      iconElement = (
        <svg
          width="36"
          height="37"
          viewBox="0 0 36 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="1"
            width="35"
            height="35"
            rx="7.5"
            fill="white"
            stroke="#E6EBF1"
          />
          <path
            d="M18.4001 21.8335L14.2334 17.6668L15.4001 16.4585L17.5667 18.6252V11.8335H19.2334V18.6252L21.4001 16.4585L22.5667 17.6668L18.4001 21.8335ZM13.4001 25.1668C12.9417 25.1668 12.5494 25.0036 12.223 24.6772C11.8966 24.3509 11.7334 23.9585 11.7334 23.5002V21.0002H13.4001V23.5002H23.4001V21.0002H25.0667V23.5002C25.0667 23.9585 24.9035 24.3509 24.5771 24.6772C24.2508 25.0036 23.8584 25.1668 23.4001 25.1668H13.4001Z"
            fill="#484646"
          />
        </svg>
      );
      break;
    case 'icon-message-disabled':
      iconElement = (
        <svg
          width="36"
          height="37"
          viewBox="0 0 36 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="1.01331"
            width="35"
            height="35"
            rx="7.5"
            fill="white"
            stroke="#E6EBF1"
          />
          <g opacity="0.2" clipPath="url(#clip0_1832_2490)">
            <path
              d="M19.7621 16.482C19.2465 16.482 18.8469 16.8816 18.8469 17.3749C18.8469 17.8682 19.2465 18.2677 19.7621 18.2677C20.2331 18.2677 20.6326 17.8682 20.6326 17.3749C20.6326 16.8816 20.2331 16.482 19.7621 16.482ZM13.5121 16.482C12.9965 16.482 12.5969 16.8816 12.5969 17.3749C12.5969 17.8682 12.9965 18.2677 13.5121 18.2677C13.9831 18.2677 14.3826 17.8682 14.3826 17.3749C14.3826 16.8816 13.9831 16.482 13.5121 16.482Z"
              fill="#595959"
            />
            <path
              d="M26.9266 14.7838C25.8939 13.3623 24.4048 12.338 22.7079 11.882V11.8843C22.3262 11.4602 21.8954 11.0695 21.4132 10.7213C17.7592 8.06509 12.6298 8.87535 9.96235 12.5294C7.81279 15.4981 7.90431 19.4914 10.0963 22.3285L10.1141 25.2883C10.1141 25.3597 10.1253 25.4312 10.1476 25.4981C10.1757 25.5876 10.2211 25.6706 10.2813 25.7425C10.3415 25.8143 10.4153 25.8736 10.4984 25.917C10.5816 25.9603 10.6724 25.9868 10.7658 25.995C10.8592 26.0032 10.9533 25.9929 11.0427 25.9646L13.8686 25.074C14.6164 25.3396 15.3887 25.4914 16.1565 25.5338L16.1454 25.5428C18.1342 26.9914 20.7414 27.4267 23.132 26.6365L25.969 27.5606C26.0405 27.5829 26.1141 27.5963 26.19 27.5963C26.5851 27.5963 26.9043 27.2771 26.9043 26.882V23.891C28.8708 21.2213 28.9222 17.5316 26.9266 14.7838ZM14.1811 23.4892L13.9132 23.3776L11.7034 24.0695L11.6811 21.7481L11.5025 21.5472C9.61413 19.2437 9.48913 15.9245 11.257 13.4892C13.4088 10.5383 17.5338 9.88651 20.4757 12.016C23.4266 14.1611 24.0807 18.2794 21.949 21.2124C20.161 23.6655 16.9601 24.5718 14.1811 23.4892ZM25.4534 23.1097L25.2749 23.3329L25.2972 25.6544L23.1097 24.9178L22.8418 25.0294C21.5918 25.4937 20.2592 25.5316 19.0248 25.1856L19.0204 25.1834C20.7169 24.6631 22.1988 23.6065 23.2436 22.1722C24.949 19.8218 25.2257 16.8687 24.2347 14.3508L24.2481 14.3597C24.7615 14.728 25.2324 15.1879 25.632 15.7437C27.2525 17.9669 27.161 20.9937 25.4534 23.1097Z"
              fill="#595959"
            />
            <path
              d="M16.6371 16.482C16.1215 16.482 15.7219 16.8816 15.7219 17.3749C15.7219 17.8682 16.1215 18.2677 16.6371 18.2677C17.1081 18.2677 17.5076 17.8682 17.5076 17.3749C17.5076 16.8816 17.1081 16.482 16.6371 16.482Z"
              fill="#595959"
            />
          </g>
          <defs>
            <clipPath id="clip0_1832_2490">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="translate(8.40015 8.51331)"
              />
            </clipPath>
          </defs>
        </svg>
      );
      break;

    case 'icon-reject-disabled':
      iconElement = (
        <svg
          width="36"
          height="37"
          viewBox="0 0 36 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="1.01318"
            width="35"
            height="35"
            rx="7.5"
            fill="white"
            stroke="#E6EBF1"
          />
          <g opacity="0.2">
            <path
              d="M11.9939 24.9194H24.8064V12.1069H11.9939V24.9194ZM15.1951 15.6636C15.1758 15.6409 15.1635 15.6132 15.1595 15.5838C15.1555 15.5544 15.1601 15.5244 15.1726 15.4974C15.1851 15.4705 15.2051 15.4477 15.2303 15.4318C15.2554 15.4159 15.2845 15.4076 15.3142 15.4077H16.4646C16.5564 15.4077 16.6443 15.4487 16.7048 15.519L18.4001 17.5405L20.0955 15.519C20.1541 15.4487 20.2419 15.4077 20.3357 15.4077H21.4861C21.6189 15.4077 21.6912 15.562 21.6052 15.6636L19.2166 18.5132L21.6052 21.3628C21.6912 21.4644 21.6189 21.6187 21.4861 21.6187H20.3357C20.2439 21.6187 20.156 21.5776 20.0955 21.5073L18.4001 19.4858L16.7048 21.5073C16.6462 21.5776 16.5583 21.6187 16.4646 21.6187H15.3142C15.1814 21.6187 15.1091 21.4644 15.1951 21.3628L17.5837 18.5132L15.1951 15.6636Z"
              fill="#E6F7FF"
            />
            <path
              d="M25.5876 10.7007H11.2126C10.8669 10.7007 10.5876 10.98 10.5876 11.3257V25.7007C10.5876 26.0464 10.8669 26.3257 11.2126 26.3257H25.5876C25.9334 26.3257 26.2126 26.0464 26.2126 25.7007V11.3257C26.2126 10.98 25.9334 10.7007 25.5876 10.7007ZM24.8064 24.9194H11.9939V12.1069H24.8064V24.9194Z"
              fill="#595959"
            />
            <path
              d="M15.3141 21.6187H16.4645C16.5582 21.6187 16.6461 21.5776 16.7047 21.5073L18.4 19.4858L20.0954 21.5073C20.1559 21.5776 20.2438 21.6187 20.3356 21.6187H21.486C21.6188 21.6187 21.6911 21.4644 21.6051 21.3628L19.2164 18.5132L21.6051 15.6636C21.6911 15.562 21.6188 15.4077 21.486 15.4077H20.3356C20.2418 15.4077 20.154 15.4487 20.0954 15.519L18.4 17.5405L16.7047 15.519C16.6442 15.4487 16.5563 15.4077 16.4645 15.4077H15.3141C15.1813 15.4077 15.109 15.562 15.195 15.6636L17.5836 18.5132L15.195 21.3628C15.1757 21.3854 15.1634 21.4131 15.1594 21.4426C15.1554 21.472 15.1599 21.502 15.1725 21.5289C15.185 21.5559 15.205 21.5786 15.2301 21.5945C15.2552 21.6104 15.2844 21.6188 15.3141 21.6187Z"
              fill="#595959"
            />
          </g>
        </svg>
      );
      break;
    case 'icon-reject':
      iconElement = (
        <svg
          width="36"
          height="37"
          viewBox="0 0 36 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="1.01318"
            width="35"
            height="35"
            rx="7.5"
            fill="white"
            stroke="#E6EBF1"
          />
          <path
            d="M11.9939 24.9194H24.8064V12.1069H11.9939V24.9194ZM15.1951 15.6636C15.1758 15.6409 15.1635 15.6132 15.1595 15.5838C15.1555 15.5544 15.1601 15.5244 15.1726 15.4974C15.1851 15.4705 15.2051 15.4477 15.2303 15.4318C15.2554 15.4159 15.2845 15.4076 15.3142 15.4077H16.4646C16.5564 15.4077 16.6443 15.4487 16.7048 15.519L18.4001 17.5405L20.0955 15.519C20.1541 15.4487 20.2419 15.4077 20.3357 15.4077H21.4861C21.6189 15.4077 21.6912 15.562 21.6052 15.6636L19.2166 18.5132L21.6052 21.3628C21.6912 21.4644 21.6189 21.6187 21.4861 21.6187H20.3357C20.2439 21.6187 20.156 21.5776 20.0955 21.5073L18.4001 19.4858L16.7048 21.5073C16.6462 21.5776 16.5583 21.6187 16.4646 21.6187H15.3142C15.1814 21.6187 15.1091 21.4644 15.1951 21.3628L17.5837 18.5132L15.1951 15.6636Z"
            fill="#E6F7FF"
          />
          <path
            d="M25.5876 10.7007H11.2126C10.8669 10.7007 10.5876 10.98 10.5876 11.3257V25.7007C10.5876 26.0464 10.8669 26.3257 11.2126 26.3257H25.5876C25.9334 26.3257 26.2126 26.0464 26.2126 25.7007V11.3257C26.2126 10.98 25.9334 10.7007 25.5876 10.7007ZM24.8064 24.9194H11.9939V12.1069H24.8064V24.9194Z"
            fill="#595959"
          />
          <path
            d="M15.3141 21.6187H16.4645C16.5582 21.6187 16.6461 21.5776 16.7047 21.5073L18.4 19.4858L20.0954 21.5073C20.1559 21.5776 20.2438 21.6187 20.3356 21.6187H21.486C21.6188 21.6187 21.6911 21.4644 21.6051 21.3628L19.2164 18.5132L21.6051 15.6636C21.6911 15.562 21.6188 15.4077 21.486 15.4077H20.3356C20.2418 15.4077 20.154 15.4487 20.0954 15.519L18.4 17.5405L16.7047 15.519C16.6442 15.4487 16.5563 15.4077 16.4645 15.4077H15.3141C15.1813 15.4077 15.109 15.562 15.195 15.6636L17.5836 18.5132L15.195 21.3628C15.1757 21.3854 15.1634 21.4131 15.1594 21.4426C15.1554 21.472 15.1599 21.502 15.1725 21.5289C15.185 21.5559 15.205 21.5786 15.2301 21.5945C15.2552 21.6104 15.2844 21.6188 15.3141 21.6187Z"
            fill="#595959"
          />
        </svg>
      );
      break;
    case 'icon-accept':
      iconElement = (
        <svg
          width="36"
          height="37"
          viewBox="0 0 36 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="1.01318"
            width="35"
            height="35"
            rx="7.5"
            fill="white"
            stroke="#E6EBF1"
          />
          <path
            d="M18.4001 9.76318C13.5681 9.76318 9.65015 13.6812 9.65015 18.5132C9.65015 23.3452 13.5681 27.2632 18.4001 27.2632C23.2322 27.2632 27.1501 23.3452 27.1501 18.5132C27.1501 13.6812 23.2322 9.76318 18.4001 9.76318ZM18.4001 25.7788C14.3884 25.7788 11.1345 22.5249 11.1345 18.5132C11.1345 14.5015 14.3884 11.2476 18.4001 11.2476C22.4119 11.2476 25.6658 14.5015 25.6658 18.5132C25.6658 22.5249 22.4119 25.7788 18.4001 25.7788Z"
            fill="#595959"
          />
          <path
            d="M18.4001 11.2476C14.3884 11.2476 11.1345 14.5015 11.1345 18.5132C11.1345 22.5249 14.3884 25.7788 18.4001 25.7788C22.4119 25.7788 25.6658 22.5249 25.6658 18.5132C25.6658 14.5015 22.4119 11.2476 18.4001 11.2476ZM22.1775 15.6558L18.0642 21.3589C18.0067 21.4391 17.9309 21.5045 17.8431 21.5496C17.7553 21.5947 17.658 21.6182 17.5593 21.6182C17.4606 21.6182 17.3633 21.5947 17.2755 21.5496C17.1877 21.5045 17.1119 21.4391 17.0544 21.3589L14.6208 17.9839C14.5466 17.8804 14.6208 17.7358 14.7478 17.7358H15.6638C15.865 17.7358 16.0525 17.8335 16.1697 17.9956L17.5603 19.9253L20.6306 15.6675C20.7478 15.5034 20.9373 15.4077 21.1365 15.4077H22.0525C22.1794 15.4077 22.2537 15.5522 22.1775 15.6558Z"
            fill="#E6F7FF"
          />
          <path
            d="M22.0525 15.4077H21.1365C20.9373 15.4077 20.7478 15.5034 20.6306 15.6675L17.5603 19.9253L16.1697 17.9956C16.0525 17.8335 15.865 17.7358 15.6638 17.7358H14.7478C14.6209 17.7358 14.5466 17.8804 14.6209 17.9839L17.0545 21.3589C17.1119 21.4391 17.1877 21.5045 17.2755 21.5496C17.3633 21.5947 17.4606 21.6182 17.5593 21.6182C17.658 21.6182 17.7553 21.5947 17.8431 21.5496C17.9309 21.5045 18.0067 21.4391 18.0642 21.3589L22.1775 15.6558C22.2537 15.5522 22.1795 15.4077 22.0525 15.4077Z"
            fill="#1890FF"
          />
        </svg>
      );
      break;
    case 'icon-accept-disabled':
      iconElement = (
        <svg
          width="36"
          height="37"
          viewBox="0 0 36 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="1.01331"
            width="35"
            height="35"
            rx="7.5"
            fill="white"
            stroke="#E6EBF1"
          />
          <g opacity="0.2">
            <rect
              x="8.90015"
              y="9.01331"
              width="19"
              height="19"
              stroke="#E6EBF1"
            />
            <path
              d="M18.4001 9.76331C13.5681 9.76331 9.65015 13.6813 9.65015 18.5133C9.65015 23.3453 13.5681 27.2633 18.4001 27.2633C23.2322 27.2633 27.1501 23.3453 27.1501 18.5133C27.1501 13.6813 23.2322 9.76331 18.4001 9.76331ZM18.4001 25.7789C14.3884 25.7789 11.1345 22.525 11.1345 18.5133C11.1345 14.5016 14.3884 11.2477 18.4001 11.2477C22.4119 11.2477 25.6658 14.5016 25.6658 18.5133C25.6658 22.525 22.4119 25.7789 18.4001 25.7789Z"
              fill="#595959"
            />
            <path
              d="M18.4001 11.2477C14.3884 11.2477 11.1345 14.5016 11.1345 18.5133C11.1345 22.525 14.3884 25.7789 18.4001 25.7789C22.4119 25.7789 25.6658 22.525 25.6658 18.5133C25.6658 14.5016 22.4119 11.2477 18.4001 11.2477ZM22.1775 15.6559L18.0642 21.359C18.0067 21.4392 17.9309 21.5046 17.8431 21.5497C17.7553 21.5948 17.658 21.6184 17.5593 21.6184C17.4606 21.6184 17.3633 21.5948 17.2755 21.5497C17.1877 21.5046 17.1119 21.4392 17.0544 21.359L14.6208 17.984C14.5466 17.8805 14.6208 17.736 14.7478 17.736H15.6638C15.865 17.736 16.0525 17.8336 16.1697 17.9957L17.5603 19.9254L20.6306 15.6676C20.7478 15.5035 20.9373 15.4078 21.1365 15.4078H22.0525C22.1794 15.4078 22.2537 15.5524 22.1775 15.6559Z"
              fill="#E6F7FF"
            />
            <path
              d="M22.0525 15.4078H21.1365C20.9373 15.4078 20.7478 15.5035 20.6306 15.6676L17.5603 19.9254L16.1697 17.9957C16.0525 17.8336 15.865 17.736 15.6638 17.736H14.7478C14.6209 17.736 14.5466 17.8805 14.6209 17.984L17.0545 21.359C17.1119 21.4393 17.1877 21.5046 17.2755 21.5497C17.3633 21.5948 17.4606 21.6184 17.5593 21.6184C17.658 21.6184 17.7553 21.5948 17.8431 21.5497C17.9309 21.5046 18.0067 21.4393 18.0642 21.359L22.1775 15.6559C22.2537 15.5524 22.1795 15.4078 22.0525 15.4078Z"
              fill="#1890FF"
            />
          </g>
        </svg>
      );
      break;
    case 'icon-arrow':
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="35"
            height="35"
            rx="7.5"
            fill="white"
            stroke="#E6EBF1"
          />
          <path
            d="M25.8978 19.7864H10.3644C10.2661 19.7864 10.1858 19.8668 10.1858 19.965V21.3043C10.1858 21.4025 10.2661 21.4828 10.3644 21.4828H23.8733L20.6523 25.5677C20.5608 25.6837 20.6434 25.8578 20.7929 25.8578H22.4112C22.5206 25.8578 22.6233 25.8087 22.6925 25.7217L26.4603 20.9427C26.8286 20.4739 26.4961 19.7864 25.8978 19.7864ZM26.4358 14.5186H12.9269L16.1478 10.4337C16.2394 10.3177 16.1568 10.1436 16.0072 10.1436H14.3889C14.2795 10.1436 14.1769 10.1927 14.1077 10.2797L10.3398 15.0587C9.9715 15.5275 10.3041 16.215 10.9001 16.215H26.4358C26.534 16.215 26.6144 16.1346 26.6144 16.0364V14.6971C26.6144 14.5989 26.534 14.5186 26.4358 14.5186Z"
            fill="#13C2C2"
          />
        </svg>
      );
      break;
    case 'icon-switch':
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="1"
            width="36"
            height="36"
            rx="7.5"
            fill="white"
            stroke="#E6EBF1"
          />
          <path
            d="M25.8977 20.2864H10.3642C10.266 20.2864 10.1857 20.3668 10.1857 20.465V21.8043C10.1857 21.9025 10.266 21.9828 10.3642 21.9828H23.8732L20.6522 26.0677C20.5607 26.1837 20.6433 26.3578 20.7928 26.3578H22.4111C22.5205 26.3578 22.6232 26.3087 22.6924 26.2217L26.4602 21.4427C26.8285 20.9739 26.4959 20.2864 25.8977 20.2864ZM26.4357 15.0186H12.9267L16.1477 10.9337C16.2392 10.8177 16.1567 10.6436 16.0071 10.6436H14.3888C14.2794 10.6436 14.1767 10.6927 14.1075 10.7797L10.3397 15.5587C9.97138 16.0275 10.304 16.715 10.9 16.715H26.4357C26.5339 16.715 26.6142 16.6346 26.6142 16.5364V15.1971C26.6142 15.0989 26.5339 15.0186 26.4357 15.0186Z"
            fill="#13C2C2"
          />
        </svg>
      );
      break;
    case 'icon-delete':
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="35"
            height="35"
            rx="7.5"
            fill="white"
            stroke="#E6EBF1"
          />
          <path
            d="M15.0312 11.5938H14.875C14.9609 11.5938 15.0312 11.5234 15.0312 11.4375V11.5938H20.9688V11.4375C20.9688 11.5234 21.0391 11.5938 21.125 11.5938H20.9688V13H22.375V11.4375C22.375 10.748 21.8145 10.1875 21.125 10.1875H14.875C14.1855 10.1875 13.625 10.748 13.625 11.4375V13H15.0312V11.5938ZM24.875 13H11.125C10.7793 13 10.5 13.2793 10.5 13.625V14.25C10.5 14.3359 10.5703 14.4062 10.6562 14.4062H11.8359L12.3184 24.6211C12.3496 25.2871 12.9004 25.8125 13.5664 25.8125H22.4336C23.1016 25.8125 23.6504 25.2891 23.6816 24.6211L24.1641 14.4062H25.3438C25.4297 14.4062 25.5 14.3359 25.5 14.25V13.625C25.5 13.2793 25.2207 13 24.875 13ZM22.2832 24.4062H13.7168L13.2441 14.4062H22.7559L22.2832 24.4062Z"
            fill="#FF4D4F"
          />
        </svg>
      );
      break;
    case 'icon-edit':
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="35"
            height="35"
            rx="7.5"
            fill="white"
            stroke="#E6EBF1"
          />
          <path
            d="M13.0332 22.6875C13.0723 22.6875 13.1113 22.6836 13.1504 22.6777L16.4355 22.1016C16.4746 22.0938 16.5117 22.0762 16.5391 22.0469L24.8184 13.7676C24.8365 13.7495 24.8508 13.728 24.8606 13.7044C24.8704 13.6808 24.8755 13.6555 24.8755 13.6299C24.8755 13.6043 24.8704 13.579 24.8606 13.5553C24.8508 13.5317 24.8365 13.5103 24.8184 13.4922L21.5723 10.2441C21.5352 10.207 21.4863 10.1875 21.4336 10.1875C21.3809 10.1875 21.332 10.207 21.2949 10.2441L13.0156 18.5234C12.9863 18.5527 12.9688 18.5879 12.9609 18.627L12.3848 21.9121C12.3658 22.0167 12.3726 22.1244 12.4045 22.2258C12.4365 22.3273 12.4928 22.4193 12.5684 22.4941C12.6973 22.6191 12.8594 22.6875 13.0332 22.6875ZM14.3496 19.2812L21.4336 12.1992L22.8652 13.6309L15.7812 20.7129L14.0449 21.0195L14.3496 19.2812ZM25.1875 24.3281H10.8125C10.4668 24.3281 10.1875 24.6074 10.1875 24.9531V25.6562C10.1875 25.7422 10.2578 25.8125 10.3438 25.8125H25.6562C25.7422 25.8125 25.8125 25.7422 25.8125 25.6562V24.9531C25.8125 24.6074 25.5332 24.3281 25.1875 24.3281Z"
            fill="#FF7A45"
          />
        </svg>
      );
      break;
    case 'icon-message':
      iconElement = (
        <svg
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="35"
            height="35"
            rx="7.5"
            fill="white"
            stroke="#E6EBF1"
          />
          <g clipPath="url(#clip0_61_5979)">
            <path
              d="M19.7623 15.9688C19.2467 15.9688 18.8472 16.3683 18.8472 16.8616C18.8472 17.3549 19.2467 17.7545 19.7623 17.7545C20.2333 17.7545 20.6329 17.3549 20.6329 16.8616C20.6329 16.3683 20.2333 15.9688 19.7623 15.9688ZM13.5123 15.9688C12.9967 15.9688 12.5972 16.3683 12.5972 16.8616C12.5972 17.3549 12.9967 17.7545 13.5123 17.7545C13.9833 17.7545 14.3829 17.3549 14.3829 16.8616C14.3829 16.3683 13.9833 15.9688 13.5123 15.9688Z"
              fill="#595959"
            />
            <path
              d="M26.9269 14.2706C25.8942 12.849 24.405 11.8248 22.7081 11.3688V11.371C22.3264 10.9469 21.8956 10.5563 21.4135 10.2081C17.7595 7.55184 12.63 8.36211 9.96259 12.0161C7.81304 14.9849 7.90456 18.9782 10.0965 21.8152L10.1144 24.7751C10.1144 24.8465 10.1255 24.9179 10.1479 24.9849C10.1759 25.0743 10.2214 25.1574 10.2816 25.2292C10.3418 25.3011 10.4155 25.3604 10.4987 25.4037C10.5818 25.4471 10.6727 25.4736 10.7661 25.4817C10.8595 25.4899 10.9535 25.4796 11.043 25.4514L13.8688 24.5608C14.6166 24.8264 15.3889 24.9782 16.1568 25.0206L16.1456 25.0295C18.1345 26.4782 20.7416 26.9134 23.1322 26.1233L25.9693 27.0474C26.0407 27.0697 26.1144 27.0831 26.1903 27.0831C26.5854 27.0831 26.9046 26.7639 26.9046 26.3688V23.3777C28.8711 20.7081 28.9224 17.0184 26.9269 14.2706ZM14.1813 22.9759L13.9135 22.8643L11.7037 23.5563L11.6813 21.2349L11.5028 21.034C9.61438 18.7304 9.48938 15.4112 11.2572 12.9759C13.409 10.0251 17.534 9.37327 20.476 11.5027C23.4269 13.6478 24.0809 17.7661 21.9492 20.6992C20.1613 23.1523 16.9604 24.0585 14.1813 22.9759ZM25.4537 22.5965L25.2751 22.8197L25.2974 25.1411L23.1099 24.4045L22.8421 24.5161C21.5921 24.9804 20.2595 25.0184 19.0251 24.6724L19.0206 24.6701C20.7171 24.1499 22.199 23.0933 23.2438 21.659C24.9492 19.3085 25.226 16.3554 24.2349 13.8376L24.2483 13.8465C24.7617 14.2148 25.2327 14.6746 25.6322 15.2304C27.2528 17.4536 27.1613 20.4804 25.4537 22.5965Z"
              fill="#595959"
            />
            <path
              d="M16.6373 15.9688C16.1217 15.9688 15.7222 16.3683 15.7222 16.8616C15.7222 17.3549 16.1217 17.7545 16.6373 17.7545C17.1083 17.7545 17.5079 17.3549 17.5079 16.8616C17.5079 16.3683 17.1083 15.9688 16.6373 15.9688Z"
              fill="#595959"
            />
          </g>
          <defs>
            <clipPath id="clip0_61_5979">
              <rect
                width="20"
                height="20"
                fill="white"
                transform="translate(8.40039 8)"
              />
            </clipPath>
          </defs>
        </svg>
      );
      break;

    case 'icon-successfully':
      iconElement = (
        <svg
          width="78"
          height="78"
          viewBox="0 0 78 78"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.5 39L34.8333 47.3333L51.5 30.6667M76.5 39C76.5 59.7107 59.7107 76.5 39 76.5C18.2893 76.5 1.5 59.7107 1.5 39C1.5 18.2893 18.2893 1.5 39 1.5C59.7107 1.5 76.5 18.2893 76.5 39Z"
            stroke="#00805A"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
      break;

    default:
      break;
  }

  if (iconElement == null) {
    return null;
  }
  return (
    <div
      className={`flex items-center justify-center ${name.indexOf('-disabled') !== -1 ? 'cursor-not-allowed' : 'cursor-pointer'} ${className}`}
      onClick={onClick}
    >
      {iconElement}
    </div>
  );
}

IconSvg.propTypes = {
  className: PropTypes.string,
  name: PropTypes.oneOf(listIcon).isRequired,
  onClick: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.oneOf([null, undefined]),
  ]),
};
